import { Row } from "reactstrap"

const DisposalPreview = props => {
  return (
    <>
      <Row>
        <h5>Application Details</h5>
        <table className="table table-striped table-responsive">
          <thead>
            <tr>
              <th>Item</th>
              <th>Value</th>
            </tr>
          </thead>

          <tbody>
            <tr>
              <td> Disposal Product Type </td>
              <td>
                {props.data.product_type_name}
              </td>
            </tr>

            <tr>
              <td>origin</td>
              <td>{props.data.origin_of_products}</td>
            </tr>

            <tr>
              <td>Quantity</td>
              <td>{props.data.quantity}</td>
            </tr>
            <tr>
              <td>Quantity Measure</td>
              <td>
                {props.data.measure_name}
              </td>
            </tr>
            <tr>
              <td>Chemical Composition</td>
              <td>{props.data.chemical_composition}</td>
            </tr>
            
            <tr>
              <td>Disposal Reasons</td>
              <td>
                {props.data.reason_name}
              </td>
            </tr>
            <tr>
              <td>Description</td>
              <td>{props.data.description}</td>
            </tr>
            <tr>
              <td>Location</td>
              <td>{props.data.location}</td>
            </tr>
          </tbody>
        </table>
      </Row>
    </>
  )
}

export default DisposalPreview
